import React, { Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Canvas, useLoader } from "@react-three/fiber";
import { PerspectiveCamera, OrthographicCamera, OrbitControls } from "@react-three/drei";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

import * as THREE from 'three';

const Scene = ({model}) => {
    //const gltf = useLoader(GLTFLoader, model, async (loader) => {});
    const manager = new THREE.LoadingManager();

    manager.onStart = function ( url, itemsLoaded, itemsTotal ) {
        console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    };
    
    manager.onLoad = function ( ) {
        console.log( 'Loading complete!');
    };
    
    manager.onProgress = function ( url, itemsLoaded, itemsTotal ) {
       // console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    };
    
    manager.onError = function ( url ) {
        console.log( 'There was an error loading ' + url );
    };
    
    const loader = new GLTFLoader( manager );

    loader.load( model, function ( object ) {
        console.log('load', object);
    } )

    return (
        <Suspense fallback={null}>
            
        </Suspense>
    )
}

function Test()
{
    const project = useSelector((state) => state.project.selectedProject);

    const [areTexturesLoaded, setAreTexturesLoad] = useState(true);
    const [model, setModel] = useState("http://192.168.1.8/easyBoardOnline/api/storage/app/public/9999/48/model.gltf");

    /*
    useEffect(() => {
        if(!project || !project.model || !project.model.gltf) {
            return;
        }

        const modelData = project.model;

        setModel(modelData.gltf.default);

        if(!project.model.textures) {
            return;
        }

        const textures = modelData.textures;

        if(!textures || textures.length === 0) {
            return;
        }

        async function preloadTextures(textures) {
            let texturesLoaded = await loadTextures(textures);

            setAreTexturesLoad(texturesLoaded);
        }

        preloadTextures(textures);
    }, [project]);

    async function fetchBlob(url) {
        const response = await fetch(url);

        return response.blob();
    }

    const loadTextures = async (textures) => {
        for(const url of textures) {
            const image = await fetchBlob(url);

            console.log(image);
        }

        return true;
    }
    */

    return (
        <Canvas gl={{ preserveDrawingBuffer: true, precision: 'lowp' }}>
            <ambientLight key="ambient" intensity={0.2} color={1} />
            <directionalLight key="directional" position={[0, 2, 3]} intensity={0.8} color={1} castShadow={false} />
            <OrthographicCamera makeDefault position={[0, 0, 0]} near={1} />
            <OrbitControls enableRotate={true} enablePan={true} target={[0, 0, 0]} />
            <gridHelper args={[10000, 400, 'black', 'blue']} position={[0,0,0]} />
            {areTexturesLoaded && <Scene model={model} />}
        </Canvas>
    );
}

export default Test;